<template>
  <div class="login-wrapper" v-loading="loading">
    <div class="login-card">
      <div class="card-body">
        <!-- 左栏：Logo -->
        <div class="card-left">
          <img :src="ossPath + 'logo.gif'" class="logo-img" alt="幻之大地">
        </div>

        <!-- 右栏：登录表单 -->
        <div class="card-right">
          <el-form :model="loginForm" ref="loginForm" label-position="top" class="login-form">
            <el-form-item prop="username">
              <el-input
                type="text"
                v-model="loginForm.username"
                placeholder="请输入账号"
                prefix-icon="el-icon-user"
              ></el-input>
            </el-form-item>

            <el-form-item prop="password">
              <el-input
                type="password"
                v-model="loginForm.password"
                placeholder="请输入密码"
                prefix-icon="el-icon-lock"
                @keyup.enter.native="submitClick"
              ></el-input>
            </el-form-item>

            <!-- 验证码区域 -->
            <el-form-item v-if="captchaItem" prop="captcha" class="captcha-form-item">
              <div class="captcha-row">
                <el-input
                  type="text"
                  class="captcha-input"
                  maxlength="4"
                  v-model="loginForm.captcha"
                  @keyup.enter.native="submitClick"
                  placeholder="请输入验证码"
                ></el-input>
                <img
                  class="captcha-img"
                  alt="点击更换"
                  title="点击更换"
                  @click="changeCode"
                  :src="codeImgSrc"
                />
              </div>
            </el-form-item>

            <!-- 登录按钮 -->
            <el-form-item class="submit-form-item">
              <el-button
                type="primary"
                class="login-btn"
                :loading="loading"
                @click.native.prevent="submitClick"
              >登 录</el-button>
            </el-form-item>

            <!-- 忘记密码 -->
            <div class="forgot-link">
              <router-link :to="{name:'sendForgetPasswordEmail'}">忘记密码？</router-link>
            </div>
          </el-form>
        </div>
      </div>

      <!-- 底部导航链接 -->
      <div class="nav-links">
        <router-link :to="{name:'register'}" class="nav-link">居民入住</router-link>
        <span class="nav-divider">|</span>
        <router-link :to="{name:'about'}" class="nav-link">关于幻地</router-link>
        <span class="nav-divider">|</span>
        <router-link :to="{name:'guideIndex'}" class="nav-link">旅游指南</router-link>
        <span class="nav-divider">|</span>
        <router-link :to="{name:'version'}" class="nav-link">版本说明</router-link>
      </div>
    </div>

    <!-- Footer -->
    <div class="login-footer">
      <div class="copyright">
        ©Copyright 2019 <a href="http://www.huanzhidadi.com" target="_blank">幻之大地</a> ALL RIGHTS RESERVED. <a href="https://beian.miit.gov.cn" target="_blank" title="豫ICP备17045248号-3">豫ICP备17045248号-3</a>
      </div>
      <div class="advice">
        抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。<br/>适度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。
      </div>
    </div>
  </div>
</template>
<script>
  import {postRequest, postJson} from '../utils/api'
  import {putRequest} from '../utils/api'
  import {getRequest} from '../utils/api'
  import Message from 'element-ui/lib/message'
  export default{
    data(){
      return {
        loginForm: {
          username: '',
          password: '',
          captcha: ''
        },
        loading: false,
        codeImgSrc: '',
        errorinfo: '',
        captchaItem: false,
      }
    },
    watch: {
    },
    mounted: function() {

    },
    methods: {
      checkInput: function(_this) {
        if (_this.loginForm.username=="") {
          Message.error('用户名不能为空！');
          return false;
        }
        if (_this.loginForm.password=="") {
          Message.error('密码不能为空！');
          return false;
        }
        if (_this.captchaItem==true && _this.loginForm.captcha=="") {
          Message.error('验证码不能为空！');
          return false;
        }
        return true;
      },
      // 登录成功后的跳转：一律走「整页加载」（2026-10-17）
      // 背景：登录后原来用 $router.replace 在 SPA 内部跳到 /main/street.html，
      // 线上出现过「登录接口 0.2s 就返回成功、页面却冻住 132 秒、浏览器弹网页无响应」，
      // 而同一次会话改成整页加载（地址栏刷新）后立刻恢复正常。日志对照：
      //   整页加载进主界面（08:24 / 14:46）→ 从不卡；SPA 内 replace 进街道（14:55）→ 偶发卡死。
      // 登录本身是低频操作，多一次整页加载几乎无感，却能一次性绕开 SPA 内跳转
      // 带来的全部隐患（页面栈/历史记录/组件复用/遮罩残留），代价远小于收益。
      goto: function (path) {
        window.location.replace(path);
      },
      submitClick: function () {
        var _this = this;
        var result = this.$options.methods.checkInput(_this);
        if (result == true) {
          this.loading = true;
          postJson('/auth/login/ajaxLogin', {
            username: this.loginForm.username,
            password: this.loginForm.password,
            captcha: this.loginForm.captcha
          }).then(resp=> {
            _this.loading = false;
            if (resp.status == 200) {
              var respData = resp.data;
              if (200 == respData.status) {
                let emailStatus = respData.data.emailStatus;
                if (emailStatus == 1) {
                  let status = respData.data.status;
                  if (status == 1) {
                    let userHeader = respData.data.userHeader;
                    if (null == userHeader) {
                      _this.goto('/initUserHeader.html');
                    } else {
                      if (null==respData.data.whereami || respData.data.whereami=="street") {
                        _this.goto('/main/street.html');
                      } else {
                        _this.goto('/main/home.html');
                      }
                    }
                  } else {
                    _this.goto('/initProperties.html');
                  }
                } else {
                  _this.goto('/unVerifyEmail.html');
                }
              } else {
                console.log(respData)
                this.captchaItem = respData.data;
                if (true == this.captchaItem) {
                  _this.changeCode();
                }
              }
            } else {
              Message.error('登录失败!');
            }
          }, resp=> {
            console.log(resp)
            _this.loading = false;
            Message.error('找不到服务器⊙﹏⊙∥!');
          });
        }

      },
      genTimestamp: function() {
        var time = new Date();
        return time.getTime();
      },
      changeCode: function() {
        var _this = this;
        // 重试上限（2026-10-17）：原来业务失败就无条件 changeCode() 自递归，
        // 后端一直返回非 200 时会无限重试、把请求打爆且永不停止。
        if (this._captchaRetry >= 3) {
          this._captchaRetry = 0;
          this.loading = false;
          Message.error('验证码获取失败，请点图片重试');
          return;
        }
        this._captchaRetry = (this._captchaRetry || 0) + 1;
        this.loading = true;
          postRequest('/auth/login/getCaptcha', {
          }).then(resp=> {
            _this.loading = false;
            if (resp.status == 200) {
              var respData = resp.data;
              if (200 == respData.status) {
                _this._captchaRetry = 0;
                _this.codeImgSrc = "data:image/jpg;base64," + respData.data
              } else {
                Message.error(respData.message);
                _this.changeCode();
              }
            } else {
              Message.error('获取验证码失败!');
            }
          }, resp=> {
            _this.loading = false;
            Message.error('找不到服务器⊙﹏⊙∥!');
          });
      }
    },
  }
</script>
<style scoped>

/* ========== 页面容器 ========== */
.login-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #f0f2f5;
  padding: 40px 16px;
  box-sizing: border-box;
}

/* ========== 登录卡片 ========== */
.login-card {
  width: 100%;
  max-width: 720px;
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08), 0 1px 4px rgba(0, 0, 0, 0.04);
  padding: 36px 40px;
  box-sizing: border-box;
}

/* ========== 卡片主体：左右栏 ========== */
.card-body {
  display: flex;
  align-items: center;
}

.card-left {
  flex: 0 0 42%;
  text-align: center;
  padding-right: 32px;
}

.card-right {
  flex: 1;
  min-width: 0;
}

/* ========== Logo ========== */
.logo-img {
  max-width: 100%;
  height: auto;
  display: inline-block;
}

/* ========== 表单 ========== */
.login-form {
  margin-top: 0;
}

.login-form .el-form-item {
  margin-bottom: 18px;
}

.login-form .el-input__inner {
  border-radius: 8px;
  height: 44px;
  line-height: 44px;
  font-size: 15px;
}

/* ========== 验证码区域 ========== */
.captcha-form-item {
  margin-bottom: 18px;
}

.captcha-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.captcha-input {
  flex: 1;
}

.captcha-img {
  width: 110px;
  height: 44px;
  border-radius: 6px;
  cursor: pointer;
  border: 1px solid #dcdfe6;
  flex-shrink: 0;
  object-fit: contain;
  background: #fafafa;
  transition: border-color 0.2s;
}

.captcha-img:hover {
  border-color: #409eff;
}

/* ========== 登录按钮 ========== */
.submit-form-item {
  margin-bottom: 12px;
}

.login-btn {
  width: 100%;
  height: 46px;
  border-radius: 8px;
  font-size: 16px;
  letter-spacing: 6px;
}

/* ========== 忘记密码 ========== */
.forgot-link {
  text-align: right;
  margin-bottom: 20px;
}

.forgot-link a {
  font-size: 13px;
  color: #909399;
  text-decoration: none;
  transition: color 0.2s;
}

.forgot-link a:hover {
  color: #409eff;
}

/* ========== 底部导航链接 ========== */
.nav-links {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding-top: 16px;
  border-top: 1px solid #ebeef5;
}

.nav-link {
  font-size: 13px;
  color: #606266;
  text-decoration: none;
  padding: 4px 6px;
  transition: color 0.2s;
  white-space: nowrap;
}

.nav-link:hover {
  color: #409eff;
}

.nav-divider {
  color: #dcdfe6;
  font-size: 14px;
  user-select: none;
}

/* ========== Footer ========== */
.login-footer {
  text-align: center;
  margin-top: 28px;
  padding: 0 16px;
}

.login-footer .copyright {
  font-size: 12px;
  color: #999;
  line-height: 1.6;
}

.login-footer .copyright a {
  color: #909399;
  text-decoration: none;
  transition: color 0.2s;
}

.login-footer .copyright a:hover {
  color: #409eff;
}

.login-footer .advice {
  font-size: 11px;
  color: #aaa;
  line-height: 1.7;
  margin-top: 6px;
}

/* ========== 移动端适配 ========== */
@media (max-width: 768px) {
  .login-wrapper {
    padding: 12px 10px;
    justify-content: flex-start;
    padding-top: 16px;
  }

  .login-card {
    max-width: 360px;
    width: 92%;
    padding: 20px 16px;
    border-radius: 12px;
  }

  .card-body {
    flex-direction: column;
  }

  .card-left {
    flex: 0 0 auto;
    width: 100%;
    text-align: center;
    padding-right: 0;
    margin-bottom: 12px;
  }

  .logo-img {
    max-width: 100px;
  }

  .login-form .el-form-item {
    margin-bottom: 10px;
  }

  .login-form .el-input__inner {
    height: 38px;
    line-height: 38px;
    font-size: 14px;
  }

  .captcha-img {
    width: 90px;
    height: 38px;
  }

  .login-btn {
    height: 42px;
    font-size: 15px;
    letter-spacing: 4px;
  }

  .forgot-link {
    margin-bottom: 12px;
  }

  .nav-links {
    padding-top: 12px;
    gap: 2px;
  }

  .nav-link {
    font-size: 12px;
    padding: 2px 4px;
  }

  .login-footer {
    margin-top: 12px;
  }

  .login-footer .copyright {
    font-size: 10px;
  }

  .login-footer .advice {
    font-size: 10px;
  }
}
</style>
